import { render, staticRenderFns } from "./GridProdutos.vue?vue&type=template&id=0e56e7ab&scoped=true"
import script from "./GridProdutos.vue?vue&type=script&setup=true&lang=js"
export * from "./GridProdutos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GridProdutos.vue?vue&type=style&index=0&id=0e56e7ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56e7ab",
  null
  
)

export default component.exports